module.exports = __webpack_public_path__ + "img/logo-card-03.e8e11ac9.png";